@let languages = appState().siteData?.knowledgeBase?.languages;

@if (languages && languages.length > 1) {
  <div (click)="$event.stopPropagation()">
  <button mat-button [matMenuTriggerFor]="menu">
    {{ ALL_LANGUAGES.get(appState().language)!.name }}

    <fa-icon [icon]="faCaretDown" class="ms-2"/>
  </button>

  <mat-menu #menu="matMenu">
    @for (lang of languages; track lang) {
      <button mat-menu-item (click)="onLanguageChangeAsync(lang)">{{ ALL_LANGUAGES.get(lang)?.name }}</button>
    }
  </mat-menu>
  </div>
}
